const getKycStatus = (eligibleBidderData: any) => {
  if (eligibleBidderData) {
    const { created_by, status, digio_request_status } = eligibleBidderData;
    if (created_by === "banker") {
      return status === "verified"
        ? "Verified Application"
        : "Incomplete Application";
    }
    if (status === "verified") return "Verified Application";
    if (status === "rejected") return "Banker Rejected";
    if (digio_request_status === "approved") return "Awaiting Banker Approval";
  }
  return "Incomplete Application";
};

export default getKycStatus;
